(function () {
  if (!location.pathname.includes('/a/loop_subscriptions')) return;

  function reparentUpCart() {
    ['upCart', 'upCartStickyButton'].forEach(function (id) {
      var node = document.getElementById(id);
      if (node && node.parentElement !== document.body) {
        document.body.appendChild(node);
      }
    });
  }

  reparentUpCart();
  document.addEventListener('DOMContentLoaded', reparentUpCart);

  new MutationObserver(reparentUpCart).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
